import React from "react";
import { contact } from "../mock";
import { Instagram, Mail, Heart, MessageCircle, MapPin } from "lucide-react";
import MMLogo from "./MMLogo";

const Footer = () => {
  return (
    <>
      {/* CTA Section */}
      <section id="contact" className="py-24 md:py-32 bg-cream">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <div className="flex justify-center mb-6">
            <MMLogo size={60} />
          </div>
          <p className="font-serif text-[11px] tracking-[0.35em] text-gold-dark mb-6">CONTACT & RÉSERVATION</p>
          <h2 className="font-serif text-4xl md:text-6xl text-brown mb-2">
            À très
            <span className="font-vibes text-gold-dark text-5xl md:text-7xl ml-3">bientôt</span>
          </h2>
          <div className="gold-divider my-6">
            <span className="w-1.5 h-1.5 rounded-full bg-gold" />
          </div>
          <p className="font-cormorant italic text-brown/80 text-xl mb-4">
            Les réservations se font via Instagram ou WhatsApp.
          </p>
          <p className="font-cormorant text-brown/70 text-base mb-12 max-w-xl mx-auto">
            Envoyez-moi un message en précisant la prestation souhaitée et vos disponibilités. Je vous répondrai personnellement dans les plus brefs délais.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <a
              href={contact.mapsUrl}
              target="_blank"
              rel="noreferrer"
              className="group bg-sand p-8 border border-taupe/40 hover:border-gold transition-colors"
            >
              <MapPin size={26} strokeWidth={1.2} className="text-gold-dark mx-auto mb-4" />
              <p className="font-serif text-[11px] tracking-[0.3em] text-brown mb-2">ADRESSE</p>
              <p className="font-cormorant text-brown text-base group-hover:text-gold-dark leading-tight">
                {contact.address}<br />5580 {contact.city}
              </p>
            </a>
            <a
              href={contact.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="group bg-sand p-8 border border-taupe/40 hover:border-gold transition-colors"
            >
              <Instagram size={26} strokeWidth={1.2} className="text-gold-dark mx-auto mb-4" />
              <p className="font-serif text-[11px] tracking-[0.3em] text-brown mb-2">INSTAGRAM</p>
              <p className="font-vibes text-2xl text-gold-dark group-hover:underline">@{contact.instagram}</p>
            </a>
            <a
              href={contact.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="group bg-sand p-8 border border-taupe/40 hover:border-gold transition-colors"
            >
              <MessageCircle size={26} strokeWidth={1.2} className="text-gold-dark mx-auto mb-4" />
              <p className="font-serif text-[11px] tracking-[0.3em] text-brown mb-2">WHATSAPP</p>
              <p className="font-cormorant text-brown text-lg group-hover:text-gold-dark">{contact.whatsapp}</p>
            </a>
            <a
              href={`mailto:${contact.email}`}
              className="group bg-sand p-8 border border-taupe/40 hover:border-gold transition-colors"
            >
              <Mail size={26} strokeWidth={1.2} className="text-gold-dark mx-auto mb-4" />
              <p className="font-serif text-[11px] tracking-[0.3em] text-brown mb-2">EMAIL</p>
              <p className="font-cormorant text-brown text-sm group-hover:text-gold-dark break-all">{contact.email}</p>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href={contact.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-outline-gold"
            >
              <MessageCircle size={14} strokeWidth={1.6} /> Réserver via WhatsApp
            </a>
            <a
              href={contact.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-gold"
            >
              <Instagram size={14} strokeWidth={1.6} /> Réserver via Instagram
            </a>
          </div>

          <p className="font-vibes text-3xl text-gold-dark mt-12">Morgane</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-taupe/30 py-10 border-t border-taupe/40">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-3">
              <MMLogo size={36} />
              <div>
                <div className="font-serif text-[11px] tracking-[0.35em] text-brown">MAISON MORGANE</div>
                <div className="font-cormorant italic text-[11px] text-brown/70">{contact.address} — 5580 {contact.city}</div>
              </div>
            </div>
            <div className="flex items-center gap-5 text-[10px] tracking-[0.25em] uppercase text-brown/70 font-serif">
              <a href={contact.mapsUrl} target="_blank" rel="noreferrer" className="hover:text-gold-dark link-underline">Itinéraire</a>
              <span>·</span>
              <a href="#tarifs" className="hover:text-gold-dark link-underline">Tarifs</a>
              <span>·</span>
              <a href={`mailto:${contact.email}`} className="hover:text-gold-dark link-underline">Contact</a>
            </div>
            <p className="font-serif text-[10px] tracking-[0.25em] text-brown/70 text-center md:text-right">
              © {new Date().getFullYear()} MAISON MORGANE<br />
              <span className="text-brown/50">Tous droits réservés</span>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
